<template>
    <div class="header">
        <div class="img" @click="goHome">
            <img src="../../assets/images/home/nav_logo_h.png" alt="甘露海藏医院" />
        </div>
        <nav class="top-nav">
            <!-- <router-link :to="item.to" v-for="(item, index) in list" :key="index" class="top-nav-link">
                <div class="item">
                    <div class="no-active" :class="[$route.path.indexOf(item.to) >= 0 ? 'active' : '']">{{item.name}}</div>
                    <div class="bottom-line" v-show="$route.path.indexOf(item.to) >= 0"></div>
                </div>
            </router-link> -->
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="首页" name="/home"></el-tab-pane>
                <el-tab-pane label="健康服务" name="/service"></el-tab-pane>
                <el-tab-pane label="七大第一" name="/theSeven"></el-tab-pane>
                <el-tab-pane label="专家团队" name="/team"></el-tab-pane>
                <el-tab-pane label="甘露海模式" name="/triTone"></el-tab-pane>
                <el-tab-pane label="集团实力" name="/groupStrength"></el-tab-pane>
            </el-tabs>
        </nav>
        <div class="menu">
            <el-dropdown trigger="click" @command="handleCommand">
                <i class="el-icon-s-fold fold"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in list" :key="item.to" :command="item.to">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
    import Bus from '../../utils/eventBus.js'
    export default {
        data() {
            var self = this
            return {
                list: [
                    { to: "/home", name: "首页" },
                    { to: "/service", name: "健康服务" },
                    { to: "/theSeven", name: "七大第一" },
                    { to: "/team", name: "专家团队" },
                    { to: "/triTone", name: "甘露海模式" },
                    { to: "/groupStrength", name: "集团实力" }
                ],
                activeName: self.$route.path,
            }
        },
        mounted() {
            Bus.$on('pageName', pageNmae => {
                console.log('接收到数据='+pageNmae)
                let serviceList = ['/service/purpose', '/service/spirit', '/service/mission', '/service/strength', '/service/characteristic']
                let groupStrengthList = ['/groupStrength/group', '/groupStrength/about', '/groupStrength/news']
                if(serviceList.indexOf(pageNmae) > -1){
                    this.activeName = '/service'
                }else if(groupStrengthList.indexOf(pageNmae) > -1){
                    this.activeName = '/groupStrength'
                }else {
                     this.activeName = pageNmae
                }
            })
            let serviceList = ['/service/purpose', '/service/spirit', '/service/mission', '/service/strength', '/service/characteristic']
            let groupStrengthList = ['/groupStrength/group', '/groupStrength/about', '/groupStrength/news']
            if(serviceList.indexOf(this.$route.path) > -1){
                this.activeName = '/service'
            }else if(groupStrengthList.indexOf(this.$route.path) > -1){
                this.activeName = '/groupStrength'
            }

        },
        methods: {
            handleClick(val){
                if(this.$route.path == val.name || this.$route.redirectedFrom == val.name){
                    return
                }else if(this.$route.path.indexOf(val.name) > -1){
                    return
                }
                this.$router.push(val.name)
            },
            handleCommand(command){
                if(this.$route.path.indexOf(command) > -1){
                    return
                }
                this.$router.push(command)
            },
            goHome() {
                // if(this.$route.path == '/home') return
                // this.$router.push('/home')
                // this.activeName = '/home'
                this.$router.push('/entryAbout')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        height: 90px;
        width: 100%;
        background: #fff;
        display: flex;
        padding: 0 110px;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        z-index: 99;
        top: 0;
        // box-shadow: 0px 0px 5px 5px #f2f2f2;
        .img {
            width: 286px;
            height: 59px;
            img {
                width: 286px;
                height: 59px;
                cursor: pointer;
            }
        }
        .top-nav {
            color: #666;
            .top-nav-link {
                color: #666;
                font-size: 16px;
                text-decoration: none;
                display: inline-block;
                .item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: #666;
                    position: relative;
                    .bottom-line {
                        width: 24px;
                        height: 2px;
                        background: #E0B747;
                        position: absolute;
                        top: 40px;
                        left: 50%;
                        margin-left: -12px;
                    }
                    .no-active {
                        color: #666;
                    }
                    .active {
                        color: #28307C;
                        font-weight: bold;
                    }
                }
                .item:hover {
                    color: #28307C;
                }
            }
            .top-nav-link:not(:last-child){
                margin-right: 75px;
            }
        }
        .menu {
            display: none;
        }
    }
    @media screen and (max-width: 800px) {
        .header {
            height: 180px;
            width: 100%;
            background: #fff;
            display: flex;
            padding: 0 110px;
            box-sizing: border-box;
            justify-content: space-between;
            align-items: center;
            position: fixed;
            z-index: 99;
            top: 0;
            .img {
                width: 572px;
                height: 118px;
                img {
                    width: 572px;
                    height: 118px;
                }
            }
            .top-nav {
                display: none;
            }
            .menu {
                display:flex;
                .fold {
                    font-size: 100px;
                }
            }
        }
    }
</style>
<style scoped>
    .el-dropdown-menu /deep/ .el-dropdown-menu__item {
        line-height: 200px!important;
        font-size: 70px!important;
        padding: 0 60px;
    }
</style>
<style scoped>
    .top-nav /deep/ .el-tabs__nav {
        height: 90px;
    }
    .top-nav /deep/ .el-tabs__item {
        height: 90px;
        line-height: 90px;
        font-size: 16px;
        padding: 0 40px;
        color: #333;
    }
    .top-nav /deep/ .el-tabs__item:hover {
        color: #28307C;
    }
    .top-nav /deep/ .el-tabs__nav-wrap::after{
        height: 0;
    }
    .top-nav /deep/ .el-tabs__active-bar {
        background-color: #E0B747;
    }
    .top-nav /deep/ .el-tabs__item.is-active {
        color: #28307C;
        font-weight: bold;
    }
    .top-nav /deep/ .el-tabs__active-bar {
        bottom: 20px;
    }
    .top-nav /deep/ .el-tabs__header {
        margin: 0;
    }
</style>